import { Translation, useTranslation } from 'react-i18next';
import React, { memo } from 'react';
import MobileModal from '../MobileModal';
import iLogoCircle from 'assets/logo-circle.svg';
import Modal from '@/components/Modal';
import { IconCloseModal, IconCloseModalMobile } from '@/assets/icon/common';

import style from './index.module.scss';

export const MobileModalTip = memo(
  ({
    visible,
    setVisible,
    content,
  }: {
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    content?: string;
  }) => {
    const { t } = useTranslation();
    return (
      <MobileModal
        modalIsOpen={visible}
        setIsShow={setVisible}
        diyStyle={{ padding: '28px 30px', overflow: 'none' }}>
        <div className={style.tipContainer}>
          <img src={iLogoCircle} alt="" />
          {content || t('MobileModalTip.pc')}
        </div>
        <div className={style.closeContainer}>
          <img
            src={IconCloseModal}
            alt="close"
            className={style.closeModalButton}
            onClick={() => setVisible(false)}
          />
        </div>
      </MobileModal>
    );
  },
);

export const moreFeatureModalTip = () => {
  Modal.info({
    hideConfirmBtn: true,
    closeable: true,
    closeIcon: <img src={IconCloseModalMobile} alt="close" />,
    className: style.sayHiModal,
    contentClassName: style.sayHiModalContent,
    content: (
      <span className={style.sayHiModalText}>
        <span className={style.primaryColor}>
          <Translation>{t => t('MobileModalTip.youun7')}</Translation>
        </span>
        <Translation>{t => t('MobileModalTip.1wvdwu5')}</Translation>
      </span>
    ),
  });
};
